import $ from 'jquery';
import { onLoad } from 'runtime';

onLoad(context => {
    $('.carousel-move-one .carousel-item', context.element).each(function() {
        var item = $(this);

        for (var i = 1; i < item.closest('.carousel-move-one').data('move'); i++) {
            item = item.next();

            // Wrap around if at end of item collection
            if (!item.length)
                item = $(this).siblings(':first');

            // Clone the item and add marker class, add to collection
            item.children(':first-child').clone()
                .addClass('cloned-item')
                .addClass('cloned-item-' + i)
                .appendTo($(this));
        }
    });
});